import React from 'react'
import { Collapse, Row, Button } from 'react-bootstrap'

const CollapseContainer = (props) => {
    return (
        <div className="mobile-collapse-container filter-row-container">
            <Row className="mobile-collapse-container">
                <Button
                    onClick={(e) => props.isOpen ? props.onCollapseClose() 
                                                 : props.onCollapseTriggerClick(e.target.textContent)}
                    className={`filter-benefits-button mobile-filter-button row ${props.isOpen ? "gray-e6-bg" : "dark"}`}
                    aria-expanded={props.isOpen}
                >
                    <span className={"selected-user spa-font-color-54a0 font-size-p2 gotham-xn-medium col-xs-10 collapse-trg-text"}>{props.triggerText}</span>
                    <svg role="img" focusable="false" className={`svg-icon svg-icon-${props.isOpen ? "close-x" : "down-arrow"}`}>
                        {props.isOpen ? <use xlinkHref="#icon-close-x" ></use> 
                                      : <use xlinkHref="#icon-down-arrow"></use>}
                    </svg>
                </Button>
                <Collapse in={props.isOpen}>
                    <div className="mobile-collapse-content no-pad-margin collapse availability-collapse-container">
                        {props.children}
                    </div>
                </Collapse>
            </Row>
        </div>
    )
}

export default CollapseContainer
